import DesCollabCreateTeamViewModel from 'viewmodel/DesCollabCreateTeamViewModel';
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCollabCreateTeam extends DesBaseCatalogAcc {
    constructor() {
        super(DesCollabCreateTeamViewModel);
    }

    get locale() {
        return this.getAttribute('locale') || 'en_US';
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }
    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'email-template-id', 'email-template-params', 'collaborationspaceid', 'locale'];
    }

}
if (!window.customElements.get('des-collab-create-team')) {
    window.customElements.define('des-collab-create-team', DesCollabCreateTeam);
}
